module.exports = __webpack_public_path__ + "static/img/pikto_wroc.9f726338.svg";